// extracted by css-extract-rspack-plugin
export default {"dialogBody":"move-items-to-iteration-menu-module__dialogBody__p0cpS"};